import { GENERAL_GLOBAL_REDUCER, RESET_ALERT, SEND_ALERT, } from "./types";
export const globalAction = (payload) => ({
    type: GENERAL_GLOBAL_REDUCER,
    payload,
});
export const sendAlert = (payload) => ({
    type: SEND_ALERT,
    payload,
});
export const resetAlert = () => ({ type: RESET_ALERT });
